import { Component, EventEmitter, Input, Output } from '@angular/core';
import { WholesaleCustomersService } from '../../services/system/wholesale-customers.service';
import { FormBuilder, Validators } from '@angular/forms';
import { Subject, tap, takeUntil } from 'rxjs';
import { autoCompleteRequired } from '../../validators/autocompleteRequired';

@Component({
  selector: 'app-wholesale-customers-dropdown',
  templateUrl: './wholesale-customers-dropdown.component.html',
  styleUrl: './wholesale-customers-dropdown.component.scss'
})
export class WholesaleCustomersDropdownComponent {

  _unsubscribe$: Subject<boolean> = new Subject()

  form = this.fb.group({
    Id: ['', [autoCompleteRequired()]],
  })

  @Input() label: string = "Common.Customer"
  @Input() dataSource: any[] | any = null
  @Input() isRequired: boolean = false
  @Output() updateParent: EventEmitter<any> = new EventEmitter();

  timeOut: any = 0

  constructor(
    private wholesaleCustomersService: WholesaleCustomersService,
    private fb: FormBuilder,
  ) { }

  ngOnInit(): void {
    if (!this.dataSource) {
      this.getData()
    }
    if (this.isRequired) {
      this.form.get('Id')?.addValidators(Validators.required)
    }
  }

  /*----------------------Functions Called from parent---------------------- */
  // setValue(data){
  //   // console.log("eventdata",data)
  //   this.userVal = `[${data.Service_Id}] - ${data.Service_Id}`;
  // }

  reset() {
    this.form.reset()
    this.updateParent.emit("");
  }

  /*----------------------Getting Users for dropdown select---------------------- */

  onType(value: string) {
    if (value.length == 0 || value.length > 1) {
      clearTimeout(this.timeOut)
      this.timeOut = setTimeout(() => {
        this.dataSource = []
        this.getData(value)
      }, 1000)
    }
  }

  getData(searchValue: string = '') {
    let body: any = {
      pageNo: 1,
      pageSize: 50,
      searchString: searchValue
    }

    this.wholesaleCustomersService.getAll(body)
      .pipe(
        tap(
          (result) => {
            if (result.IsSuccess && result.Data) {
              this.dataSource = result.Data;
            }
          }
        ),
        takeUntil(this._unsubscribe$),
      )
      .subscribe();
  }


  /*----------------------when Choosing User---------------------- */
  changeSelected(selectedValue: any) {
    if (selectedValue) {
      let Id = (this.form.get('Id')?.value as any).Id
      this.updateParent.emit(Id);
    } else {
      this.updateParent.emit("");
    }
  }

  displayFn(item: any) {
    if (!item) return '';
    let index = this.dataSource.findIndex((e: any) => e.Id == item.Id);
    return `${this.dataSource[index].Name} - [${item.Phone}]`;
  }

  ngOnDestroy(): void {
    this._unsubscribe$.next(true)
    this._unsubscribe$.complete()
  }
}
